import { render, staticRenderFns } from "./createshipments.vue?vue&type=template&id=b0485800&"
import script from "./createshipments.vue?vue&type=script&lang=js&"
export * from "./createshipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports